<template>
  <div id="printBoxBig" >
    <!-- <div style="font-size:30px;color:#000c17;text-align:center;width:100%;">请稍等一会...</div> -->
    <div id="printBox" style="border: 1px solid #000c17;">
      <div class="titler">
        <table class="gridtable">
          <thead>
          <!-- <tr>
            <th colspan="9"></th>
            <th colspan="4" style="text-align: left;font-size: 18px;line-height: 18px;font-weight: 600">报价</th>
          </tr> -->
          <tr>
            <th colspan="5" style="line-height: 18px;text-align: left;font-size: 18px;line-height: 18px;font-weight: 600">
              {{ datas.buyYearTenant.tenantName }}
            </th>
            <th colspan="7" style="text-align: left;">
              <p style="font-size: 15px;font-weight: 600;padding:0">采购订单:</p>
              <p style="font-size: 12px;font-weight:400;padding:0;margin-top:-10px;">No: {{datas.order.code}}</p>
            </th>
          </tr>
          <tr style="padding-top: 0px;margin-top: 0px;">
            <th colspan="5" style="font-weight: 400;text-align: left;">
              <div><span
                style="font-size: 12px;">地址: {{ datas.buyYearTenant.address }}</span></div>
              <div><span style="font-size: 12px;">电话: {{ datas.buyYearTenant.mobile }}</span></div>
            </th>
            <th colspan="7" style="font-weight: 400;text-align: left;">
              <div>
                <span style="font-size: 12px;">订单日期:</span><span
                style="font-size: 12px">{{ datas.order.createTime }}</span>
              </div>
              <div>
                <span style="font-size: 12px;">打印日期:</span>
                <span style="font-size: 12px;">{{ datas.printTime }}</span>
              </div>
            </th>
          </tr>
          <tr style="border-top:1px solid #000;">
            <th colspan="5"
                style="line-height: 12px;font-weight: 400;text-align: left;border-top:1px solid #000;border-right:1px solid #000;">
              <div>
                <span style="font-size: 12px">供应商:</span> <span
                style="font-size: 12px">{{ datas.sellerTenant.tenantName }}</span>
              </div>
              <div>
                <span style="font-size: 12px">地址:</span> <span
                style="font-size: 12px">{{ datas.sellerTenant.address }}</span>
              </div>
            </th>
            <th colspan="3"
                style="line-height: 12px;font-weight: 400;text-align: left;border-top:1px solid #000;border-right:1px solid #000;">
              <div>
                <span style="font-size: 12px">联系人:</span> <span
                style="font-size: 12px">{{ datas.sellerTenant.applicant}}</span>
              </div>
              <div>
                <span style="font-size: 12px">票据类型:</span>
                 <span style="font-size: 12px" v-if="datas.order.invoiceTitle == 0" >不开发票</span>
                 <span style="font-size: 12px" v-if="datas.order.invoiceTitle == 1" >平台发票</span>
                 <span style="font-size: 12px" v-if="datas.order.invoiceTitle == 2" >供应商发票</span>
              </div>
            </th>
            <th colspan="4" style="line-height: 12px;font-weight: 400;text-align: left;border-top:1px solid #000;">
              <div style="">
                <span style="font-size: 12px">联系电话:</span><span
                style="font-size: 12px">{{ datas.sellerTenant.mobile }}</span>
              </div>
              <div style="display: flex;">
                <div style="flex: 1">
                  <span style="font-size: 12px">结算方式:</span>
                  <span style="font-size: 12px" v-if="datas.order.payType === 0">额度</span>
                  <span style="font-size: 12px" v-if="datas.order.payType === 1">现金</span>
                  <span style="font-size: 12px" v-if="datas.order.payType === 2">货到付款</span>
                </div>
                <div style="flex: 1">
                  <span style="font-size: 12px">仓库:</span>
                  <!-- <span style="font-size: 12px">{{onelist.storeName}}</span> -->
                </div>
              </div>
            </th>
          </tr>
          <tr style="text-align: left;line-height: 12px;">
            <th
              style="width:5%;padding: 2px 0;font-size: 12px; font-weight: 400;border-top: 2px solid #000; text-align: left;border-right: 1px solid #000;border-bottom:1px solid #000;">
              序号
            </th>
            <th
              style="width:13%;padding: 2px 0;font-size: 12px;font-weight: 400; border-top: 2px solid #000;borer-left:2px solid #000; text-align: left;border-right: 1px solid #000;border-bottom:1px solid #000;">
              配件编码
            </th>
            <th
              style="width:10%;padding: 2px 0;font-size: 12px; font-weight: 400;border-top: 2px solid #000;borer-left:2px solid #000; text-align: left;border-right: 1px solid #000;border-bottom:1px solid #000;">
              配件名称
            </th>
            <th
              style="width: 13%;padding: 2px 0;font-size: 12px;font-weight: 400; border-top: 2px solid #000;borer-left:2px solid #000; text-align: left;border-right: 1px solid #000;border-bottom:1px solid #000;">
              OEM码
            </th>
            <th
              style="width: 10%;padding: 2px 0;font-size: 12px;font-weight: 400; border-top: 2px solid #000; text-align: left;border-right: 1px solid #000;border-bottom:1px solid #000;">
              品牌
            </th>
            <th
              style="width: 7%;padding: 2px 0;font-size: 12px;font-weight: 400; border-top: 2px solid #000; text-align: left;border-right: 1px solid #000;border-bottom:1px solid #000;">
              车型
            </th>
            <th
              style="width: 10%;padding: 2px 0;font-size: 12px;font-weight: 400; border-top: 2px solid #000; text-align: left;border-right: 1px solid #000;border-bottom:1px solid #000;">
              规格
            </th>
            <th
              style="width: 4%;padding: 2px 0;font-size: 12px;font-weight: 400; border-top: 2px solid #000; text-align: left;border-right: 1px solid #000;border-bottom:1px solid #000;">
              单位
            </th>
            <th
              style="width: 4%;padding: 2px 0;font-size: 12px;font-weight: 400; border-top: 2px solid #000; text-align: left;border-right: 1px solid #000;border-bottom:1px solid #000;">
              数量
            </th>
            <th
              style="width: 7%;padding: 2px 0;font-size: 12px;font-weight: 400; border-top: 2px solid #000; text-align: left;border-right: 1px solid #000;border-bottom:1px solid #000;">
              单价
            </th>
            <th
              style="width: 7%;padding: 2px 0;font-size: 12px;font-weight: 400; border-top: 2px solid #000; text-align: left;border-bottom:1px solid #000;border-right: 1px solid #000;">
              金额
            </th>
             <th
              style="width: 6%;padding: 2px 0;font-size: 12px;font-weight: 400; border-top: 2px solid #000; text-align: left;border-bottom:1px solid #000;">
              货位
            </th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item ,index) in datas.parts" :key="index">
            <td
              style="font-size: 12px; border-bottom: 1px solid #000; text-align: left;border-right: 1px solid #000;padding: 2px 0;">
              {{index + 1}}
            </td>
            <td style="border-bottom: 1px solid #000; text-align: left;border-right: 1px solid #000;padding: 2px 0;">
              <div style="font-size: 12px;overflow: hidden;word-break:break-all;line-height: 12px;">
                {{item.oeCode}}
              </div>
            </td>
            <td style="border-bottom: 1px solid #000; text-align: left;border-right: 1px solid #000;padding: 2px 0;">
              <div style="font-size: 12px;overflow: hidden;word-break:break-all;line-height: 12px;height: 12px">
                {{item.stdNameJp}}
              </div>
            </td>
            <td style="border-bottom: 1px solid #000; text-align: left;border-right: 1px solid #000;padding: 2px 0;">
              <div v-for="item1 in item.oemCode" :key="item1" style="font-size: 12px;overflow: hidden;word-break:break-all;line-height: 12px;height: 12px">
                {{item1}}
              </div>
            </td>
            <td style="border-bottom: 1px solid #000; text-align: left;border-right: 1px solid #000;padding: 2px 0;">
              <div style="font-size: 12px;overflow: hidden;word-break:break-all;line-height: 12px;">
                {{item.carBrandName}}
              </div>
            </td>
            <td style="border-bottom: 1px solid #000; text-align: left;border-right: 1px solid #000;padding: 2px 0;">
              <div v-if="item.carModel != null" style="font-size: 12px;overflow: hidden;word-break:break-all;line-height: 12px;height: 12px">
                {{item.carModel[0]}}
              </div>
              <div v-else style="font-size: 12px;overflow: hidden;word-break:break-all;line-height: 12px;height: 12px">
                {{item.carModel}}
              </div>
            </td>
            <td style="border-bottom: 1px solid #000; text-align: left;border-right: 1px solid #000;padding: 2px 0;">
              <div v-if="item.partsSpec != null"  style="font-size: 12px;overflow: hidden;word-break:break-all;line-height: 12px;">
                <!-- <div v-for="i in item.partsSpec" :key="i">
                 {{i}}
                </div> -->
                {{item.partsSpec[0]}}
              </div>
              <div v-else style="font-size: 12px;overflow: hidden;word-break:break-all;line-height: 12px;height: 12px">
                {{item.partsSpec}}
              </div>
            </td>
            <td style="border-bottom: 1px solid #000; text-align: left;border-right: 1px solid #000;padding: 2px 0;">
              <div style="font-size: 12px;overflow: hidden;word-break:break-all;line-height: 12px;height: 12px">
                {{item.unitId}}
              </div>
            </td>
            <td style="border-bottom: 1px solid #000; text-align: left;border-right: 1px solid #000;padding: 2px 0;">
              <div style="font-size: 12px;overflow: hidden;word-break:break-all;line-height: 12px;">
                {{item.partNum}}
              </div>
            </td>
            <td style="border-bottom: 1px solid #000; text-align: left;border-right: 1px solid #000;padding: 2px 0;">
              <div style="font-size: 12px;overflow: hidden;word-break:break-all;line-height: 12px;">
                {{item.price}}
              </div>
            </td>
            <td style="border-bottom: 1px solid #000; text-align: left;padding: 2px 0; border-right: 1px solid #000;">
              <div style="font-size: 12px;overflow: hidden;word-break:break-all;line-height: 12px;">
                {{item.money}}
              </div>
            </td>
            <td style="border-bottom: 1px solid #000; text-align: left;padding: 2px 0;">
              <div style="font-size: 12px;overflow: hidden;word-break:break-all;line-height: 12px;">
                {{item.cargoSpace}}
              </div>
            </td>
          </tr>
          <tr style="font-size: 12px;line-height: 12px;">
            <td colspan="7" style="padding: 0 2px;margin-top: 0;border-right: 1px #000000 solid;">
              <span>合计:</span>
              <span>{{ datas.amountCNY }}</span>
            </td>
            <td colspan="2" style="padding: 0 2px;border-right: 1px #000000 solid;">
              <span>总数: </span>
              <span>{{ datas.partsNumSum }}</span>
            </td>
            <td colspan="3" style="padding: 0 2px;">
              <span>合计: </span>
              <span>{{ datas.amount }}</span>
            </td>
          </tr>
          <tr style="font-size: 12px;line-height: 12px;">
            <td colspan="3"
                style="padding: 2px;margin-top: 0;border: 1px #000000 solid;border: 1px #000000 solid;border-left: none;">
              <span>制单人:</span>
              <span>{{ datas.preparedBy }}</span>
            </td>
            <td colspan="3"
                style="padding: 2px;margin-top: 0;border: 1px #000000 solid;border: 1px #000000 solid;border-left: none;">
              <span>提交人:</span>
              <span>{{ datas.order.createUname }}</span>
            </td>
            <td colspan="3"
                style="padding: 2px;margin-top: 0;border: 1px #000000 solid;border: 1px #000000 solid;border-left: none;">
              <span>送货人:</span>
            </td>
            <td colspan="3"
                style="padding: 2px;margin-top: 0;;border: 1px #000000 solid;border-left: none;border-right: none;">
              <span>收货人:</span>
            </td>
          </tr>
          <tr>
            <td colspan="12" style="border-bottom: 1px solid #000c17;padding: 0;margin: 0">
              <span style="color:#000;font-size: 14px;font-weight: 600;word-break:break-all;">备注：{{datas.order.remark}}</span>
            </td>
          </tr>
          <tr>
            <td colspan="12" style="padding-top:15px ;margin: 0">
              <span style="color:#000;font-size: 14px;font-weight: 600;">
                兹收到上列货物完整无缺，所有电器配件货物出门概不退货，灯，胶，玻璃等易碎物品必须当面校验清楚，事后概不负责！此单据一经客户或其代理人签名，将作为客户欠款凭证，特此声明
               </span>
            </td>
          </tr>
          <!-- <tr>
            <td colspan="12" style="padding: 0;margin: 0">
              <span style="color:#000;font-size: 14px;font-weight: 600;">{{tips}}</span>
            </td>
          </tr> -->
          <div>
          </div>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import {print} from '@/api/business/bought.js'
export default {
  data(){
    return{
      datas:{
        buyYearTenant:{},
        inputWarehouse:[],
        order:{},
        printTime:'',
        purchase:'',
        sellerTenant:{},
        systemName:"",
        totalAmt:0,//合计金额
      }
    }
  },

  methods:{
   async jjj(id){
      let res = await print(id)
      if(res.status) {
        console.log(res.data);
        this.datas = res.data
        // this.totalAmt=this.datas.parts.reduce((total, curr) => total += Number(curr.money), 0)
        setTimeout( () =>{
          this.print()
        })
      }
    },
    print(){
      let iframe = document.getElementById("print-iframe");
        if (!iframe) {
          let el = document.getElementById("printBox");
          iframe = document.createElement('IFRAME');
          let doc = null;
          iframe.setAttribute("id", "print-iframe");
          iframe.setAttribute('style', 'position:absolute;width:0px;height:0px;left:-500px;top:-500px;');
          document.body.appendChild(iframe);
          doc = iframe.contentWindow.document;
          doc.write('<div>' + el.innerHTML + '</div>');
          doc.close();
          iframe.contentWindow.focus();
        }
      iframe.contentWindow.print();
      document.body.removeChild(iframe);
      // this.remove_ie_header_and_footer()
    },
      //去除页眉页脚
    // remove_ie_header_and_footer() {
    //   var hkey_path;
    //   hkey_path = "HKEY_CURRENT_USER\\Software\\Microsoft\\Internet Explorer\\PageSetup\\";
    //   try {
    //     var RegWsh = new ActiveXObject("WScript.Shell");
    //     RegWsh.RegWrite(hkey_path + "header", "");
    //     RegWsh.RegWrite(hkey_path + "footer", "");
    //   } catch (e) {
    //   }
    // },
  }
}
</script>


<style scoped lang="less">
  /*@media print*/
  /*{*/
  /*  #printBox {page-break-after:always !important;}*/
  /*}*/
  .vertical-center-modal {
    display: flex;
    align-items: center;
    justify-content: center;

    .ivu-modal {
      top: 0;
    }
  }

  #printBox {
    width: 730px;
    margin: 0 auto;
    overflow: hidden;
    overflow-y: scroll;

    .titler {
      width: 100%;
      padding-left: 2px;
    }
  }

  #printBox::-webkit-scrollbar {
    display: none;
  }

  #printBox {
    -ms-overflow-style: none;
  }

  #printBox::-webkit-scrollbar {
    width: 0 !important;
  }

  #printBox {
    overflow: -moz-scrollbars-none;
  }

  #printBox.ivu-modal-wrap.ivu-modal-content.ivu-modal-close {
    display: none !important;
    width: 0 !important;
    z-index: -1 !important;
  }

  //表格样式
  table.gridtable {
    width: 100%;
    font-family: verdana, arial, sans-serif;
    font-size: 10px !important;
    table-layout: fixed; /*列宽由表格宽度和列宽度设定。*/
    color: #000000;
    border-width: 1px;
    border-color: #000000;
    text-align: left;
    border-collapse: collapse;
    /*page-break-before: always;*/
    /*bor*/
  }

  table.gridtable th {
    border-width: 1px;
    padding: 4px 2px;
    border-style: solid;
    border-color: #000000;
    background-color: #dedede;
  }

  table.gridtable td {
    border-width: 1px;
    padding: 4px 2px;
    border-style: solid;
    border-color: #000000;
    background-color: #ffffff;
  }

  table.gridtable tr {
    page-break-inside: avoid;
  }

  table.gridtable tr th {
    font-weight: 400 !important;
  }
  
</style>
<style media="print">
    @page {
        size: auto;  /* auto is the initial value */
        margin: 0mm; /* this affects the margin in the printer settings */
    }
</style>